module.exports = __webpack_public_path__ + "static/iranloye-c3eccb46ccc9bdd540e99931b60f8e51.jpg";